import { Component } from "@angular/core";
import { FeatureFlagsService } from "src/app/services/feature-flag/feature-flag.service";

@Component({
  selector: 'app-choose-plan-wrapper',
  template: `
    <app-plans-page *ngIf="useRebranded"></app-plans-page>
    <app-choose-plan *ngIf="!useRebranded"></app-choose-plan>
  `
})
export class ChoosePlanWrapperComponent {
  public useRebranded: boolean;

  constructor(private featureFlagService: FeatureFlagsService) {
    this.useRebranded = this.featureFlagService.isEnabled('useRebrandedLayout');
  }
}
